import { useMemo, useState } from "react";
import { BookOpen } from "lucide-react";
import { ArticleCard } from "../components/Blog";
import { PageShell } from "../components/PageShell";

export default function NotesPage({ posts, loading, error }) {
  const [category, setCategory] = useState("All");
  const categories = useMemo(
    () => ["All", ...new Set(posts.map((post) => post.category).filter(Boolean))],
    [posts],
  );
  const visiblePosts = category === "All" ? posts : posts.filter((post) => post.category === category);

  return (
    <PageShell section="Notes">
      <main className="notes-page" id="main">
        <header className="notes-index__intro">
          <div>
            <h1>Notes, gathered in one place.</h1>
            <p>
              Clear explanations from Dr. Neerja’s learning desk—for patients, families,
              and fellow professionals. These notes are educational and do not replace care
              from a clinician who knows your situation.
            </p>
          </div>
          <p className="notes-index__count" aria-live="polite">
            {loading && !posts.length ? "Loading notes…" : `${posts.length} ${posts.length === 1 ? "note" : "notes"}`}
          </p>
        </header>

        <section className="notes-index__body" aria-labelledby="notes-collection-title">
          <header className="notes-index__toolbar">
            <div>
              <h2 id="notes-collection-title">Browse the collection</h2>
              <p>Choose a subject, then open any note to read it at your own pace.</p>
            </div>
            {categories.length > 1 && (
              <div className="filter-row notes-index__filters" aria-label="Filter notes by category">
                {categories.map((item) => (
                  <button
                    type="button"
                    className={category === item ? "is-active" : ""}
                    aria-pressed={category === item}
                    onClick={() => setCategory(item)}
                    key={item}
                  >
                    {item}
                  </button>
                ))}
              </div>
            )}
          </header>

          {!loading && error && !visiblePosts.length && <p className="content-message content-message--error">{error}</p>}

          {!loading && !error && !visiblePosts.length && (
            <div className="journal-empty">
              <BookOpen size={28} aria-hidden="true" />
              <h3>No notes in this subject yet.</h3>
              <p>Choose another subject to continue browsing.</p>
            </div>
          )}

          {!!visiblePosts.length && (
            <div className="notes-collection">
              {visiblePosts.map((post) => <ArticleCard post={post} key={post.id} />)}
            </div>
          )}
        </section>
      </main>
    </PageShell>
  );
}
